import { render, staticRenderFns } from "./AddEcCustomer.vue?vue&type=template&id=5c8a5213&scoped=true"
import script from "./AddEcCustomer.vue?vue&type=script&lang=ts"
export * from "./AddEcCustomer.vue?vue&type=script&lang=ts"
import style0 from "./AddEcCustomer.vue?vue&type=style&index=0&id=5c8a5213&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a5213",
  null
  
)

export default component.exports